import { forwardRef } from 'react';
import styles from './styleConstants.module.css';

const cx = (base: string, extra?: string) => (extra ? `${base} ${extra}` : base);

export const H1 = forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithoutRef<'h1'>
>(({ className, ...props }, ref) => (
  <h1 ref={ref} className={cx(styles.h1, className)} {...props} />
));
H1.displayName = 'H1';

export const H1_OPT = forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithoutRef<'h1'>
>(({ className, ...props }, ref) => (
  <h1 ref={ref} className={cx(styles.h1Opt, className)} {...props} />
));
H1_OPT.displayName = 'H1_OPT';

export const H2 = forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithoutRef<'h2'>
>(({ className, ...props }, ref) => (
  <h2 ref={ref} className={cx(styles.h2, className)} {...props} />
));
H2.displayName = 'H2';

export const H2Large = forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithoutRef<'h2'>
>(({ className, ...props }, ref) => (
  <h2 ref={ref} className={cx(styles.h2Large, className)} {...props} />
));
H2Large.displayName = 'H2Large';

export const PLargeGradient = forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<'p'>
>(({ className, ...props }, ref) => (
  <p ref={ref} className={cx(styles.pLargeGradient, className)} {...props} />
));
PLargeGradient.displayName = 'PLargeGradient';

export const H2_OPT = forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithoutRef<'h2'>
>(({ className, ...props }, ref) => (
  <h2 ref={ref} className={cx(styles.h2Opt, className)} {...props} />
));
H2_OPT.displayName = 'H2_OPT';

export const H2Small = forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithoutRef<'h2'>
>(({ className, ...props }, ref) => (
  <h2 ref={ref} className={cx(styles.h2Small, className)} {...props} />
));
H2Small.displayName = 'H2Small';

export const H3 = forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithoutRef<'h3'>
>(({ className, ...props }, ref) => (
  <h3 ref={ref} className={cx(styles.h3, className)} {...props} />
));
H3.displayName = 'H3';

export const P_OPT = forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<'p'>
>(({ className, ...props }, ref) => (
  <p ref={ref} className={cx(styles.pOpt, className)} {...props} />
));
P_OPT.displayName = 'P_OPT';

export const PBody = forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<'p'>
>(({ className, ...props }, ref) => (
  <p ref={ref} className={cx(styles.pBody, className)} {...props} />
));
PBody.displayName = 'PBody';

export const P = forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<'p'>
>(({ className, ...props }, ref) => (
  <p ref={ref} className={cx(styles.p, className)} {...props} />
));
P.displayName = 'P';

export const PLarge = forwardRef<
  HTMLParagraphElement,
  React.ComponentPropsWithoutRef<'p'>
>(({ className, ...props }, ref) => (
  <p ref={ref} className={cx(styles.pLarge, className)} {...props} />
));
PLarge.displayName = 'PLarge';

// Should be used only inside <Container>
export const LeftSideTextWrapper = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<'div'>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cx(styles.leftSideTextWrapper, className)} {...props} />
));
LeftSideTextWrapper.displayName = 'LeftSideTextWrapper';
